import * as types from "../actionTypes"

/**
 * Clears the events from the clipboard.
 * @return {Object} An FSA action.
 */
export const clearClipboard = () => ({
  type: types.CLEAR_CLIPBOARD,
})
